<template>
    <div class="col-12">
        <div class="row">
            <div class="col-md-4">
                <label>{{ __('company_name_or_first_name_and_second_name') }}</label>
                <input :value="contractor.name" class="form-control" disabled type="text">
            </div>

            <div class="col-md-2">
                <label>{{ __('country') }}</label>
                <input :value="contractor.country" class="form-control" disabled type="text">
            </div>

            <div class="col-md-2">
                <label>{{ __('identification_number_id') }}</label>
                <input :value="contractor.idNumberType" class="form-control" disabled type="text">
            </div>

            <div class="col-md-4">
                <label>{{ __('identification_number') }}</label>
                <input :value="contractor.idNumber" class="form-control" disabled type="text">
            </div>

            <div v-if="displayDetails" class="col-md-6">
                <div class="row m-b-sm">
                    <div class="col-md-12 m-b-sm">
                        <label>{{ __('full_address') }}</label>
                        <input :value="contractor.address" class="form-control" disabled type="text">
                    </div>
                    <div class="col-md-12 m-b-sm">
                        <input :value="contractor.address2" class="form-control" disabled type="text">
                    </div>
                    <div class="col-md-6 m-b-sm">
                        <label>{{ __('zip') }}</label>
                        <input :value="contractor.zip" class="form-control" disabled type="text">
                    </div>
                    <div class="col-md-6 m-b-sm">
                        <label>{{ __('city') }}</label>
                        <input :value="contractor.city" class="form-control" disabled type="text">
                    </div>
                </div>
            </div>
            <div v-if="displayDetails" class="col-md-6">
                <div class="form-group">
                    <label>{{ __('remarks') }}</label>
                    <textarea
                        :value="contractor.remarks"
                        class="form-control"
                        disabled
                        style="height:126px;"
                    ></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContractorDisplayForm",
    props: {
        contractor: {
            type: Object,
            required: true,
        },
        displayDetails: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
